import { Component, OnInit } from '@angular/core';
import { TicketpaymentService } from "../ticket-payment/ticketpayment.service";
import { ActivatedRoute } from "@angular/router";
import { createQRCodeFromTicketParams } from "@foh/shared/services/utils";
@Component({
  selector: 'app-display-qrcode',
  templateUrl: './display-qrcode.component.html',
  styleUrls: ['./display-qrcode.component.scss']
})
export class DisplayQrcodeComponent implements OnInit {
  routeObs$: any;
  token: any;
  referenceId: any;
  eventName : string;
  customerName : string;
  customerMobile : string;
  ticketName : string;
  code : string;
  date : string;
  signature : string=null;
  loading: boolean=false;
  qrCodeLink: string;

  constructor(private activeRoute: ActivatedRoute,
    private ticketpaymentService: TicketpaymentService) { }

  ngOnInit() {
    this.routeObs$ = this.activeRoute.params.subscribe(params => {
      this.token = params["token"];
      this.referenceId = params["ticketrefid"];
      this.retrieve();
    });
  }

  retrieve() {
    this.loading = true;
    this.ticketpaymentService
      .retrievePaidTicket({ token: this.token,referenceid:this.referenceId })
      .subscribe((response: any) => {
        this.loading = false;
        this.eventName = response.eventName;
        this.customerName = response.customerName;
        this.customerMobile = response.customerMobile;        
        this.ticketName = response.ticketName;
        this.code = response.code;
        //this.signature = response.signature;
        var jsonText = this.retrieveJsonString(response);
        this.qrCodeLink = "https://quickchart.io/qr?margin=1&text="+jsonText;
      });
  }

  retrieveJsonString(response){
    return createQRCodeFromTicketParams(response)
  }

}
